import { useEffect, useState } from 'react';

// Inline styles can't use CSS media queries, so components branch on these.
// Desktop (>= 1024px) is the default layout and must never be affected:
// every mobile/tablet style is applied only when one of these flags is true.
const MOBILE_QUERY = '(max-width: 639.98px)';
const TABLET_QUERY = '(min-width: 640px) and (max-width: 1023.98px)';
// Devices without a hover-capable fine pointer (phones, tablets).
const TOUCH_QUERY = '(hover: none), (pointer: coarse)';

function matches(query) {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(query).matches;
}

function read() {
  return {
    isMobile: matches(MOBILE_QUERY),
    isTablet: matches(TABLET_QUERY),
    isTouch: matches(TOUCH_QUERY),
  };
}

export default function useBreakpoint() {
  const [state, setState] = useState(read);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const lists = [MOBILE_QUERY, TABLET_QUERY, TOUCH_QUERY].map(q => window.matchMedia(q));
    const onChange = () => setState(read());
    lists.forEach(l => (l.addEventListener ? l.addEventListener('change', onChange) : l.addListener(onChange)));
    onChange();
    return () => {
      lists.forEach(l => (l.removeEventListener ? l.removeEventListener('change', onChange) : l.removeListener(onChange)));
    };
  }, []);

  return {
    ...state,
    // < 1024px: anything that isn't the untouched desktop layout.
    isCompact: state.isMobile || state.isTablet,
  };
}
